import time from './dist/time'
import cookie from './dist/cookie'
import url from './dist/url'
import validator from './dist/validator'
import toFinancialNum from './dist/toFinancialNum'
import autoTextarea from './dist/autoTextarea'
import keyMatcher from './dist/keyMatcher'
import https from './dist/https'
import detectType from './dist/detectType'
import money from './dist/money'
import PDF from 'pdfjs-dist'

export {
	time,
	cookie,
	url,
	validator,
	toFinancialNum,
	autoTextarea,
	keyMatcher,
	https,
	detectType,
	money,
	PDF, // 修改第三方 PDFjs 代码后输出
};



//////////////////
// WEBPACK FOOTER
// ./~/_apec-fe-utils@1.1.3@apec-fe-utils/index.js
// module id = 540
// module chunks = 2 3